export default __webpack_public_path__ + "media/images/backgrounds/vegetables-c0c63be59ce095e1dcff5af21f9e1be1.svg";